import React, {useState, useEffect, useRef} from 'react'
import './ConfirmOrder.scss'
import Banner from '../../Molecules/Banner/Banner';
import Loader from '../../Atoms/Loader/Loader';
import { Checkbox, Button, Input, Radio, Form, Alert } from 'antd';
import Icon from '@ant-design/icons';
import {WhatsAppOutlined} from '@ant-design/icons';
//import { EnvironmentFilled, PhoneOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import {withRouter, Link} from 'react-router-dom';
// import alerta from '../../../utilityFunctions/alerta';
import EmptyCart from '../../Molecules/EmptyCart/EmptyCart';
import Swal from 'sweetalert2';
import {validateNotEmpty} from '../../validation/validations';
import { SAVE_LOGIN_USER } from '../../../redux/actions';
import { getOrders } from '../../../redux/actionCreators';
import store from '../../../redux/store';
import {useTranslation} from 'react-i18next';

const CustonSvg = () => (
  <svg id="Layer_1"  width="1.3em" height="1.3em"   fill="#006BB6" viewBox="0 0 512 512"  xmlns="http://www.w3.org/2000/svg"><g>
    <path d="m496.761 352.176c7.89-.429 14.161-6.952 14.161-14.958 0-43.164-34.648-76.976-78.879-76.976h-14.617l-17.866-84.802c17.24-7.49 29.332-24.692 29.332-44.675 0-26.842-21.811-48.68-48.621-48.68h-69.115c-8.274 0-14.982 6.716-14.982 15v18.68h-36.828c-8.274 0-14.982 6.716-14.982 15s6.708 15 14.982 15h36.828v18.68c0 8.284 6.708 15 14.982 15h6.652c-12.404 14.669-19.907 33.618-19.907 54.299v85.359c0 .438-.355.793-.792.793h-60.52c-.349 0-.661-.233-.76-.568l-16.315-55.202c13.149-3.517 22.865-15.542 22.865-29.801 0-33.857-27.511-61.401-61.326-61.401h-134.987c-25.4-.001-46.066 20.69-46.066 46.122 0 23.25 17.273 42.526 39.644 45.666-23.732 21.254-38.697 52.13-38.697 86.444v46.699c0 8.284 6.708 15 14.982 15h12.963c6.978 34.84 37.766 61.17 74.587 61.17s67.609-26.33 74.587-61.17h183.27c6.978 34.84 37.766 61.17 74.587 61.17 41.948 0 76.076-34.17 76.076-76.17.001-17.124-5.675-32.943-15.238-45.679zm-18.256-29.958h-33.727c-2.907-.339-5.858-.533-8.854-.533-5.37 0-10.608.568-15.666 1.632v-33.075h11.786c21.942 0 40.083 13.207 46.461 31.976zm-152.368-210.134h54.134c10.288 0 18.658 8.38 18.658 18.68s-8.37 18.68-18.658 18.68h-54.134zm-89.547 237.811h60.52c16.959 0 30.755-13.813 30.755-30.793v-85.359c0-25.782 18.086-47.416 42.223-52.849l20.207 95.91v60.143c-14.662 11.039-25.221 27.252-28.958 45.907h-148.95c-6.997-53.818-51.439-94.083-106.909-94.083-24.735 0-46.941 8.08-64.461 21.97 14.472-27.092 43.004-45.571 75.776-45.571h71.786l18.522 62.67c3.836 12.986 15.963 22.055 29.489 22.055zm-204.462 32.959c2.618-15.958 9.435-30.353 19.86-41.507 13.607-14.559 32.603-22.577 53.488-22.577 38.642 0 69.859 27.156 76.561 64.083h-149.909zm13.938-147.684c-8.879 0-16.103-7.233-16.103-16.124s7.224-16.124 16.103-16.124h134.987c17.294 0 31.363 14.086 31.363 31.401-.128.617-1.116 1.025-2.955.845-12.464 0-8.901 0-11.497 0-17.901.002-151.811.002-151.898.002zm57.413 208.854c-20.183 0-37.367-13.055-43.601-31.17h87.202c-6.234 18.115-23.418 31.17-43.601 31.17zm332.445 0c-25.427 0-46.113-20.712-46.113-46.17s20.687-46.169 46.113-46.169c25.427 0 46.113 20.711 46.113 46.169s-20.687 46.17-46.113 46.17z"/><ellipse cx="435.924" cy="397.855" rx="15.081" ry="15.099"/><path d="m15.61 129.443h134.368c8.274 0 14.982-6.716 14.982-15s-6.708-15-14.982-15h-134.368c-8.274 0-14.982 6.716-14.982 15s6.708 15 14.982 15z"/><path d="m65.382 67.976h135.526c8.274 0 14.982-6.716 14.982-15s-6.708-15-14.982-15h-135.526c-8.274 0-14.982 6.716-14.982 15s6.708 15 14.982 15z"/></g>
  </svg>
);

const CustonIcon = props => <Icon component={CustonSvg} {...props} />;

const CustonSvg2 = () => (
  <svg id="Layer_1"  width="1.3em" height="1.3em"   fill="#9e9999" viewBox="0 0 512 512"  xmlns="http://www.w3.org/2000/svg"><g>
    <path d="m496.761 352.176c7.89-.429 14.161-6.952 14.161-14.958 0-43.164-34.648-76.976-78.879-76.976h-14.617l-17.866-84.802c17.24-7.49 29.332-24.692 29.332-44.675 0-26.842-21.811-48.68-48.621-48.68h-69.115c-8.274 0-14.982 6.716-14.982 15v18.68h-36.828c-8.274 0-14.982 6.716-14.982 15s6.708 15 14.982 15h36.828v18.68c0 8.284 6.708 15 14.982 15h6.652c-12.404 14.669-19.907 33.618-19.907 54.299v85.359c0 .438-.355.793-.792.793h-60.52c-.349 0-.661-.233-.76-.568l-16.315-55.202c13.149-3.517 22.865-15.542 22.865-29.801 0-33.857-27.511-61.401-61.326-61.401h-134.987c-25.4-.001-46.066 20.69-46.066 46.122 0 23.25 17.273 42.526 39.644 45.666-23.732 21.254-38.697 52.13-38.697 86.444v46.699c0 8.284 6.708 15 14.982 15h12.963c6.978 34.84 37.766 61.17 74.587 61.17s67.609-26.33 74.587-61.17h183.27c6.978 34.84 37.766 61.17 74.587 61.17 41.948 0 76.076-34.17 76.076-76.17.001-17.124-5.675-32.943-15.238-45.679zm-18.256-29.958h-33.727c-2.907-.339-5.858-.533-8.854-.533-5.37 0-10.608.568-15.666 1.632v-33.075h11.786c21.942 0 40.083 13.207 46.461 31.976zm-152.368-210.134h54.134c10.288 0 18.658 8.38 18.658 18.68s-8.37 18.68-18.658 18.68h-54.134zm-89.547 237.811h60.52c16.959 0 30.755-13.813 30.755-30.793v-85.359c0-25.782 18.086-47.416 42.223-52.849l20.207 95.91v60.143c-14.662 11.039-25.221 27.252-28.958 45.907h-148.95c-6.997-53.818-51.439-94.083-106.909-94.083-24.735 0-46.941 8.08-64.461 21.97 14.472-27.092 43.004-45.571 75.776-45.571h71.786l18.522 62.67c3.836 12.986 15.963 22.055 29.489 22.055zm-204.462 32.959c2.618-15.958 9.435-30.353 19.86-41.507 13.607-14.559 32.603-22.577 53.488-22.577 38.642 0 69.859 27.156 76.561 64.083h-149.909zm13.938-147.684c-8.879 0-16.103-7.233-16.103-16.124s7.224-16.124 16.103-16.124h134.987c17.294 0 31.363 14.086 31.363 31.401-.128.617-1.116 1.025-2.955.845-12.464 0-8.901 0-11.497 0-17.901.002-151.811.002-151.898.002zm57.413 208.854c-20.183 0-37.367-13.055-43.601-31.17h87.202c-6.234 18.115-23.418 31.17-43.601 31.17zm332.445 0c-25.427 0-46.113-20.712-46.113-46.17s20.687-46.169 46.113-46.169c25.427 0 46.113 20.711 46.113 46.169s-20.687 46.17-46.113 46.17z"/><ellipse cx="435.924" cy="397.855" rx="15.081" ry="15.099"/><path d="m15.61 129.443h134.368c8.274 0 14.982-6.716 14.982-15s-6.708-15-14.982-15h-134.368c-8.274 0-14.982 6.716-14.982 15s6.708 15 14.982 15z"/><path d="m65.382 67.976h135.526c8.274 0 14.982-6.716 14.982-15s-6.708-15-14.982-15h-135.526c-8.274 0-14.982 6.716-14.982 15s6.708 15 14.982 15z"/></g>
  </svg>
);

const CustonIcon2 = props => <Icon component={CustonSvg2} {...props} />;

const ConfirmOrder = (props) => {
  const { t } = useTranslation();
  const [order, setOrder] = useState([])
  const [acceptTerms, setAcceptTerms] = useState(false)
  const [userAcceptDelivery, setUserAcceptDelivery] = useState(false)
  const [deliveryAddress, setDeliveryAddress] = useState(null)
  const [deliveryPhone, setDeliveryPhone] = useState(null)
  const [loadings, setLoadings] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [showAddressForm, setShowAddressForm] = useState(false);
  const [formError, setFormError] = useState('');
  const formRef = useRef(null);
  const secondFormRef = useRef(null);
  const [phoneError, setPhoneError] = useState('');

  let showOrder = true
  let totalPriceOrder = 0
  let sellerDeliveryTypeId = false

  // Loader del boton 
  const enterLoading = index => {
    const newLoadings = [...loadings]
    newLoadings[index] = true
    setLoadings(newLoadings)
  }

  // const history = useHistory();

  useEffect(() => {
    document.body.scrollIntoView({block:'start'})
    let orderCurrent = []
    fetch(`${process.env.REACT_APP_API_URL}/orders-by-buyer/${props.userInfo.person.userId}`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    })
    .then(resp => resp.json())
    .then(resp => {
      orderCurrent = resp.findOrders.filter(od => od.id === parseInt(props.match.params.orderId))
      setOrder(orderCurrent)
   
     
      // Si la tienda esta eliminada pero por alguna razon llega a esta parte de flujo
      if( orderCurrent[0] && orderCurrent[0].orderItem[0].product === null || orderCurrent[0].orderItem[0].product.store.blocked) {
        props.history.push('/carrito');
      } else {
        setIsLoading(false);
      }
    })
    
  }, [props.match.params.orderId, props.userInfo.person.userId])


    // Calcula el total de la orden

  const getTotal = orderArr => {
    let total=0;
    orderArr.forEach(product=>{
      total += product.quantity * product.productPrice
    })
    return total;
    }

  const getDeliveryTypeId = orderArr => {
    let result = false;
    orderArr.forEach(order => {
      if(order.product.store.deliveryTypeId[0] === 1) {
        result = true
      }
    })
    return result
  }

  // show order
  const showOrderValid = orderArr => {
    let result = 0;
    orderArr.forEach(order => {
      if(order.status === 'En carrito') {
        result = true 
      } else {
        result = false 
      }
    })
    return result;
  }

  showOrder = showOrderValid(order)


  // Comprueba que haya aceptado los terminos
  const onChange = (e) => {
  
    setAcceptTerms(e.target.checked)
  }

  // Si el usario quiere delevery se muestra el input para la direccion
  const changeAcceptDelivery = (e) => {
    
    setUserAcceptDelivery(e.target.value)
    if (!e.target.value) {
      setShowAddressForm(false)
      setDeliveryPhone(null)
      setDeliveryAddress(null)
    } else {
      if (props.userInfo.person.location.length>0) {
        let userAddress = props.userInfo.person.location[0].address.split('+++').join(', ');
        if (props.userInfo.person.location[0].additionalInformation) {
          userAddress = [userAddress, props.userInfo.person.location[0].additionalInformation].join(' / ');
        }
        setDeliveryAddress(userAddress);
        setDeliveryPhone(props.userInfo.person.location[0].phoneNumber)
      }
    }
    
  }

  //go to payment
  const goToPayment = ({order}) => {
    props.history.push({
      pathname: '/pago-orden',
      state: {
        order,
      }
    });
  }

  // Enviar la order
  const sendOrder = () => {
    
    setFormError('');
    let allValid = true;
    let formAddress;
    let finalDeliveryAddress = deliveryAddress;
    let finalPhoneNumber = deliveryPhone;
    if (showAddressForm) {  //si el usuario introdujo una nueva direccion, usar esa en vez de la que tiene registrada en el perfil
      formAddress = formRef.current.getFieldsValue();
      const validCity = validateNotEmpty(formAddress.city);
      const validPhone = formAddress.phone ? formAddress.phone.length === 9 ? !isNaN(formAddress.phone) ? true:false:false:false;
      const validPostalCode = validateNotEmpty(formAddress.postalCode);
      const validProvince = validateNotEmpty(formAddress.province);
      const validStreet = validateNotEmpty(formAddress.street);
      if (validCity === '' && validPhone  && validPostalCode === '' && validProvince === '' && validStreet === '') {
        allValid = true;
        finalDeliveryAddress = [formAddress.street, formAddress.postalCode, formAddress.city, formAddress.province].join(', ')
        finalPhoneNumber = '+34'+formAddress.phone;
        if (formAddress.additional) {
          finalDeliveryAddress = [finalDeliveryAddress, formAddress.additional.trim()].join(' / ');
        }
      } else {
        allValid = false
      }
    } else if (props.userInfo.person.location.length === 0 && !userAcceptDelivery) {
      const actualPhone = secondFormRef.current.getFieldsValue().phone;
      if (actualPhone ? actualPhone.length===9 ? !isNaN(actualPhone) ? true:false:false:false) {
        setPhoneError('');
        finalPhoneNumber = '+34'+actualPhone;
      } else {
        //return setPhoneError(t("location-validation", {a: ' '}))
        return secondFormRef.current.validateFields()
      }
    } else if (!userAcceptDelivery && props.userInfo.person.location.length > 0) {
      finalPhoneNumber = props.userInfo.person.location[0].phoneNumber
    }
    if (allValid) {
      enterLoading(0)
      Promise.all([
        fetch(`${process.env.REACT_APP_API_URL}/make-order/${props.match.params.orderId}/${order[0].orderItem[0].product.store.userId}`, {
          method: 'PATCH',
          headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
          body: JSON.stringify({
            "buyerName":  `${props.userInfo.person.firstName} ${props.userInfo.person.lastName !== null && props.userInfo.person.lastName}`,
            "email":  props.userInfo.email,
            // "status": "Reservado",
            "totalPrice": parseFloat(totalPriceOrder),
            "deliveryAddress": finalDeliveryAddress,
            "buyerPhoneNumber": finalPhoneNumber,
            "personId": props.userInfo.person.userId,
            "deliveryConfirmed": false,
            "sellerId": order[0].orderItem[0].product.store.userId,
            "mySellerId": props.userInfo.person.userId,
            esp: localStorage.getItem('i18nextLng') === 'CA' || localStorage.getItem('i18nextLng') === 'ca-ES' ? false : true
          })
        })
        .then(resp => resp.json()),
        
        (showAddressForm && props.userInfo.person.location.length===0) ? 
        fetch(`${process.env.REACT_APP_API_URL}/create-location/${props.userInfo.id}`, { 
          method: 'POST',
          headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
          body: JSON.stringify([{
              address: [formAddress.street, formAddress.postalCode, formAddress.city, formAddress.province].join(', '),
              personId: props.userInfo.person.id,
              additionalInformation: formAddress.additional,
              phoneNumber: '+34'+formAddress.phone
          }])
        })
        .then(res => res.json()): null
      ])
      .then(allResp=> {
        
        if(allResp[0].message === 'Order made') {
          // alerta('Orden reservada')
          store.dispatch(getOrders(props.userInfo.person.userId)) //Cuando agrego al Carrito me actualiza el store
          // props.history.push('/carrito')

          goToPayment({order: allResp[0].findOrder});
          
        } 
        else if(allResp[0].message === 'not allowed - blocked') {
          enterLoading(1);
          Swal.fire({
            icon: 'error',
            title: t('error', {a: ' '}),
            text: t('cant-buy', {a: ' '})
          })
        }
        else {
          enterLoading(0)
          Swal.fire({
            icon: 'error',
            title: t('oops', {a: ' '}),
          })
        }
        if (allResp[1] && allResp[1].message === 'location created') {
          props.dispatch({
            type: SAVE_LOGIN_USER,
            data: allResp[1].findUser
          });
        }
      })
      .catch(err=>{
        setFormError(t('cant-buy', {a: ' '}))
      })
    } else {
      setFormError(t("location-validation", {a: ' '}))
    }
  }
  return (
    <>
      <div className="cart-container">
        <Banner title={t('confirmation', {a: ' '})}/>
        {console.log('order', order)}
        {/* Verifico si ya cargaron las ordenes */}
        {isLoading? <Loader /> :
        !showOrder ? <EmptyCart message={t('completed-order', {a: ' '})}/> :
        <>
        <div className="main-factura-data-seller">
          {/* <Link to={`/vendedor/${order[0].storeId}/${order[0].sellerName.trim().toLowerCase().replace(/\s+/g, '-')}`}> */}
          <Link to={`/vendedor/${order[0].storeId}`}>
            <h5 className="main-factura-data-seller-title">{t('seller', {a: ' '})}: {order[0].sellerName}</h5>
          </Link>
        </div>
        <div className="main-factura round-box box">
          <div className="main-factura-header">
            <h5 className="main-factura-header-title">{t('products', {a: ' '})}</h5>
            <h5 className="main-factura-header-subtitle">{t('subtotal', {a: ' '})}</h5>
          </div>

          {/* Informacion de orden */}
          <div className="main-factura-body">
            {
              order.map(od => (
                od.orderItem.map(oi => (
                  <div className="main-factura-item" key={oi.id}>
                    <p className="main-factura-quantity">{`${oi.productName}`} <span>{`x${oi.quantity}`}</span></p>
                    <p className="main-factura-subtotal">{`${oi.quantity * oi.productPrice}€`}</p>
                  </div>
                ))
              ))
            }
          </div>
          {/* Total */}
          <div>
            {
              order.map(od => (
                <div className="main-factura-total">
                  <h5>{t('total2', {a: ' '})}: </h5>
                  <p>{`${(totalPriceOrder = getTotal(od.orderItem))}€`}</p>
                  {sellerDeliveryTypeId = getDeliveryTypeId(od.orderItem)}
                </div>
              ))
            }
          </div>
          {/* Condiciones */}
          <div className="main-condiciones">
          <div className="main-condiciones-box-first">
            <div className="main-condiciones-box-first-Checkbox">
              <Checkbox onChange={onChange}>
                
              </Checkbox>
            </div>
            <div className="main-condiciones-box-first-data">
              <h5 className="main-condiciones-box-first-data-title">{t('accept-conditions2', {a: ' '})}</h5>
              <p className="main-condiciones-box-first-data-terms gray-text">{t('accept-conditions', {a: ' '})}</p>
              <Link className="main-condiciones-box-first-data-terms-link" to='/terminos-y-condiciones' rel='noopener noreferrer' target="_blank">{t('read-again', {a: ' '})}</Link>
            </div>
          </div>
            {
              !sellerDeliveryTypeId &&
              <div  className="main-condiciones-box-second mt-15">
                <div className="main-condiciones-box-first-icon">
                  <CustonIcon2 />
                </div>
                <div className="main-condiciones-box-first-data">
                  <h5 className="main-condiciones-box-first-data-title">{t('no-delivery2', {a: ' '})}</h5>
                  <p className="main-condiciones-box-first-data-terms gray-text">{t('retirar', {a: ' '})}</p>
                </div>
              </div>
            }
            {
              props.userInfo.person.location.length === 0 && !sellerDeliveryTypeId &&
              <div className="main-condiciones-form-number mt-15">
                <div className="main-condiciones-form-number-icon">
                  <div>
                    <WhatsAppOutlined />
                  </div>
                  <div className="main-condiciones-form-number-data">
                    <h5 className="main-condiciones-box-first-data-title WhatsApp">{t('get-phone', {a: ' '})}</h5>
                    <p className="main-condiciones-box-first-data-terms gray-text">{t('get-phone2', {a: ' '})}</p>
                  </div>
                </div>
                <Form ref={secondFormRef} name='phone-form' className="main-condiciones-form-number-container">
                  <Form.Item name='phone' hasFeedback rules={[{validator: (_,value)=>value ? typeof Number(value) === 'number' ? String(value).length === 9 ? Promise.resolve():Promise.reject(t('phone-valid', {a: ' '})):Promise.reject(t('numeric', {a: ' '})):Promise.reject(t('required', {a: ' '}))}]}>
                      <Input maxLength={9} addonBefore="+34" placeholder={t('contact-phone', {a: ' '})} className='text-input' />
                  </Form.Item>
                  {phoneError && <Alert message={phoneError} type='error' className='error-msg' />}
                </Form>
              </div>
            }

            <div className="main-condiciones-box-three">
                {
                  sellerDeliveryTypeId &&
                  <div className="main-condiciones-box-second-form mt-15">
                    <div className="main-condiciones-box-first-icon">
                      <CustonIcon style={{ color: 'hotpink' }} />
                    </div>
                    <div className="main-condiciones-box-first-data">
                      <h5 className="main-condiciones-box-first-data-title">{t('have-delivery', {a: ' '})}</h5>
                      <Radio.Group className="main-condiciones-RadioGroup" onChange={changeAcceptDelivery.bind(this)} value={userAcceptDelivery}>
                        <Radio className="main-condiciones-box-first-data-terms gray-text" value={false}>{t('no-want-delivery', {a: ' '})}</Radio>
                        <Radio className="main-condiciones-box-first-data-terms gray-text" value={true}>{t('yes-want-delivery', {a: ' '})}</Radio>
                      </Radio.Group>
                    </div>
                    
                  </div>
                }

                {
                  userAcceptDelivery ?
                  <>
                  {props.userInfo.person.location.length>0 ? 
                    <>
                      <p className="confirm-delivery-address-data">{t('confirm-delivery-address', {a: ' '})} ({deliveryAddress})?</p>
                      <Button type='primary' className="round-btn btn-first" onClick={()=>setShowAddressForm(false)}>{t('confirm-direction', {a: ' '})}</Button>
                      <Button type='secondary' className="round-btn" onClick={()=>setShowAddressForm(true)}>{t('no-confirm-direction', {a: ' '})}</Button>
                    </> 
                    :
                    !showAddressForm && setShowAddressForm(true)
                  }
                  {showAddressForm && 
                  <>
                    <Form ref={formRef} name='user-address-form' className="s-100 user-address-form">
                      <h5 className='user-address-form-title s-100'>{t("specify-address", {a: ' '})}: </h5>
                      <div className="container-form-item">
                          <Form.Item name='street' label={t("complete-address", {a: ' '})} hasFeedback rules={[{whitespace: true, required: true, message: t('required', {a: ' '})}]}>
                              <Input placeholder={t("complete-address", {a: ' '})} className='text-input container-form-item--inpu' />
                          </Form.Item>
                          <Form.Item name='postalCode' label={t("postal-code", {a: ' '})} hasFeedback rules={[{validator:(_, value)=> value?typeof Number(value) === 'number' ? String(value).length === 5 ? Promise.resolve():Promise.reject(t('postal-valid', {a: ' '})):Promise.reject(t('numeric', {a: ' '})):Promise.reject(t('required', {a: ' '}))},{required: true, message: ' '}]}>
                              <Input placeholder={t("postal-code", {a: ' '})} className='text-input container-form-item--inpu' />
                          </Form.Item>
                      </div>
                      <Form.Item name='city' label={t("city", {a: ' '})} hasFeedback rules={[{whitespace: true, required: true, message: t('required', {a: ' '})}]}>
                          <Input placeholder={t("city", {a: ' '})} className='text-input' />
                      </Form.Item>
                      <Form.Item name='province' label={t("province", {a: ' '})} hasFeedback rules={[{whitespace: true, required: true, message: t('required', {a: ' '})}]}>
                          <Input placeholder={t("province", {a: ' '})} className='text-input' />
                      </Form.Item>
                      <Form.Item name='phone' label={t("phone", {a: ' '})} rules={[{validator:(_, value)=> value?value.length === 9 ? !isNaN(value)?Promise.resolve():Promise.reject(t('numeric', {a: ' '})):Promise.reject(t('phone-valid', {a: ' '})):Promise.reject(t('required', {a: ' '}))},{required: true, message: ' '}]}>
                          <Input addonBefore="+34" placeholder={t("phone", {a: ' '})} className='text-input' />
                      </Form.Item>
                      <Form.Item name='additional' label={t("additional-info", {a: ' '})} hasFeedback rules={[{whitespace: true, message: t('not-empty', {a: ' '})}]}>
                          <Input placeholder={t("additional-info", {a: ' '})} className='text-input' />
                      </Form.Item>
                      {/*<Form.Item>  
                          <Button htmlType='submit' type='primary' className='btn btn-first' loading={buttonLoading}>Guardar dirección</Button>
                      </Form.Item>*/}
                      {formError && <Alert message={formError} type='error' className='error-msg' />}
                    </Form>
                  </>
                  }
                  {/*<Input onChange={changeDeliveryAddress.bind(this)} className="input-delivery text-input" placeholder="Direción del delivery" prefix={<EnvironmentFilled />} />
                  <Input onChange={changeDeliveryPhone.bind(this)} className="input-phone text-input" placeholder="Teléfono" prefix={<PhoneOutlined />} />*/}
                  </>
                  :
                  sellerDeliveryTypeId && !userAcceptDelivery &&
                  <>
                  {
                    props.userInfo.person.location.length === 0 && 
                    <div className="main-condiciones-form-number mt-15">
                    <div className="main-condiciones-form-number-icon">
                      <div>
                        <WhatsAppOutlined />
                      </div>
                      <div className="main-condiciones-form-number-data">
                        <h5 className="main-condiciones-box-first-data-title WhatsApp">{t('get-phone', {a: ' '})}</h5>
                        <p className="main-condiciones-box-first-data-terms gray-text">{t('get-phone2', {a: ' '})}</p>
                      </div>
                    </div>
                    <Form ref={secondFormRef} name='phone-form' className="main-condiciones-form-number-container">
                      <Form.Item name='phone' hasFeedback rules={[{validator: (_,value)=>value ? typeof Number(value) === 'number' ? String(value).length === 9 ? Promise.resolve():Promise.reject(t('phone-valid', {a: ' '})):Promise.reject(t('numeric', {a: ' '})):Promise.reject(t('required', {a: ' '}))}]}>
                          <Input maxLength={9} addonBefore="+34" placeholder={t('contact-phone', {a: ' '})} className='text-input' />
                      </Form.Item>
                      {phoneError && <Alert message={phoneError} type='error' className='error-msg' />}
                    </Form>
                  </div>
                  }
                  </>
                }
              </div>
              <div className="main-buttons-order">
              <Button danger onClick={props.history.goBack} className="round-btn">{t('cancel', {a: ' '})}</Button>
                {
                  acceptTerms
                  ? <Button onClick={sendOrder.bind(this)} loading={loadings[0]} className="round-btn btn-first" type="primary">{t('make-order', {a: ' '})}</Button>
                  : <Button disabled className="round-btn btn-first" type="primary">{t('make-order', {a: ' '})}</Button>
                }
              </div>
          </div>
        </div> 
        </>
    }
      </div>
    </>
  )
}

const mapStateToProps = (state) => ({
  userInfo: state.userReducer.userInfo
})
export default withRouter(connect(mapStateToProps)(ConfirmOrder))
